import { useCallback, useState, useEffect } from "react";

// For Authentik, the URL structure is inconsistent:
// - authorize endpoint: does NOT include app slug
// - end-session endpoint: DOES include app slug
const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY || "";
const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID || "";

// Extract base URL (remove application slug from authority)
const getBaseAuthURL = (authority: string): string => {
  // Authority is like: https://domain.com/application/o/scout-webapp/
  // We need: https://domain.com/application/o/
  const match = authority.match(/^(https?:\/\/[^/]+\/application\/o\/)/);
  return match ? match[1] : authority;
};

interface UseOIDCAuthReturn {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  handleCallback: () => Promise<any>;
  user: any | null;
}

export default function useOIDCAuth(): UseOIDCAuthReturn {
  const [user, setUser] = useState<any | null>(null);

  useEffect(() => {
    // Check for existing authentication state
  }, []);

  const login = useCallback(async (): Promise<void> => {
    // Authorization endpoint does NOT include app slug
    const baseURL = getBaseAuthURL(OIDC_AUTHORITY);
    const authUrl = new URL(`${baseURL}authorize/`);
    authUrl.searchParams.set("client_id", OIDC_CLIENT_ID);
    authUrl.searchParams.set("response_type", "code");
    authUrl.searchParams.set("scope", "openid profile email");
    authUrl.searchParams.set("redirect_uri", `${window.location.origin}/auth/callback`);
    authUrl.searchParams.set("state", Math.random().toString(36).substring(2, 15));
    
    window.location.href = authUrl.toString();
  }, []);

  const logout = useCallback(async (): Promise<void> => {
    localStorage.removeItem("token");
    setUser(null);
    
    // End-session endpoint DOES include app slug (use full authority)
    const logoutUrl = new URL(`${OIDC_AUTHORITY}end-session/`);
    logoutUrl.searchParams.set("post_logout_redirect_uri", window.location.origin);
    
    window.location.href = logoutUrl.toString();
  }, []);

  const handleCallback = useCallback(
    async (): Promise<any> => Promise.resolve(null),
    []
  );

  return { login, logout, handleCallback, user };
}
